import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerContent: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    containerContant: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    containerIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: `1px solid ${theme.palette.border.secondary}`,
      borderRadius: "12px",
    },
    containerModule: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    containetrCourseModuleItem: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
    },
    containerCourseModuleName: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      alignItems: "flex-start",
    },
    DescStyle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "24px",
      color: theme.palette.text.tertiary,
    },
    titleStyle: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "28px",
      color: theme.palette.text.primary,
    },
    moduleName: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
  };
});
